import { render, staticRenderFns } from "./SipPhone.vue?vue&type=template&id=49b0433c&"
import script from "./SipPhone.vue?vue&type=script&lang=js&"
export * from "./SipPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports